var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedXLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_806_961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C10.8464 0 12.9725 0.952099 14.5116 2.4883C16.0478 4.0274 16.9999 6.15365 16.9999 8.49986C16.9999 10.8464 16.0476 12.9723 14.5116 14.5114C12.9726 16.0479 10.8464 16.9999 8.5 16.9999C6.15365 16.9999 4.0274 16.0479 2.4883 14.5116C0.9521 12.9725 0 10.8464 0 8.49986C0 6.15365 0.9521 4.0274 2.4883 2.4883C4.02754 0.952099 6.15365 0 8.5 0ZM10.1618 5.41654C10.5423 5.03027 11.1608 5.02847 11.5433 5.41294C11.9257 5.79699 11.9273 6.42176 11.5471 6.80789L9.87793 8.50069L11.5487 10.1954C11.9261 10.5787 11.9208 11.1993 11.5375 11.5818C11.154 11.9645 10.5374 11.9634 10.1604 11.5801L8.50069 9.89744L6.83818 11.5836C6.45773 11.97 5.83932 11.9717 5.4568 11.5871C5.07454 11.2031 5.07275 10.5784 5.4532 10.1923L7.12207 8.49931L5.45112 6.80457C5.07399 6.42148 5.07911 5.80072 5.46247 5.41806C5.84596 5.03553 6.46257 5.0365 6.83957 5.41986L8.49931 7.1027L10.1618 5.41654ZM13.4056 3.59424C12.1504 2.33902 10.4161 1.56276 8.5 1.56276C6.58377 1.56276 4.84946 2.33902 3.59424 3.59438C2.33902 4.84959 1.56276 6.5839 1.56276 8.5C1.56276 10.4161 2.33902 12.1505 3.59424 13.4056C4.84946 14.661 6.58377 15.4374 8.5 15.4374C10.4161 15.4374 12.1504 14.6611 13.4056 13.4056C14.6608 12.1505 15.4371 10.4161 15.4371 8.5C15.4371 6.5839 14.661 4.84959 13.4056 3.59424Z",
    fill: "#FF4141"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.49931,
    cy: 8.50028,
    rx: 7.55302,
    ry: 7.55302,
    fill: "#FF4141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1618 5.4168C10.5422 5.03054 11.1608 5.02874 11.5433 5.4132C11.9257 5.79725 11.9272 6.42203 11.547 6.80815L9.8779 8.50096L11.5487 10.1957C11.9261 10.5789 11.9207 11.1995 11.5375 11.5821C11.154 11.9647 10.5374 11.9636 10.1604 11.5804L8.50066 9.8977L6.83815 11.5839C6.4577 11.9703 5.83929 11.9719 5.45676 11.5873C5.07451 11.2034 5.07271 10.5786 5.45316 10.1925L7.12204 8.49957L5.45109 6.80483C5.07396 6.42175 5.07908 5.80099 5.46243 5.41832C5.84593 5.0358 6.46254 5.03676 6.83953 5.42012L8.49927 7.10297L10.1618 5.4168Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_806_961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16.9999,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedXLineIcon);
export default __webpack_public_path__ + "static/media/red-x-line-icon.f96bbf3d14c732b9f3327b7e8eeeb33a.svg";
export { ForwardRef as ReactComponent };